import { Subject } from 'rxjs';

export class PendingStructsManager {
  private lastPendingStructs: Map<number, number> = new Map();
  private pendingStrcutSyncCount: number = 0;
  private readonly pendingStructsSyncThreshold?: number;

  private readonly _pendingStructsSyncReachedThreshold$ = new Subject<void>();
  public readonly pendingStructsSyncReachedThreshold$ =
    this._pendingStructsSyncReachedThreshold$.asObservable();

  constructor(pendingStructsSyncThreshold?: number) {
    this.pendingStructsSyncThreshold = pendingStructsSyncThreshold;
  }

  /**
   * Determines if missing updates should be synced based on the pending structs
   * @param missingStructs Current missing structs from Y.Doc
   * @returns true if sync should occur, false otherwise
   */
  public shouldSyncMissingUpdates(missingStructs: Map<number, number>): boolean {
    for (const [key, value] of missingStructs) {
      if (this.lastPendingStructs.get(key) !== value) {
        this.pendingStrcutSyncCount = 1;
        this.lastPendingStructs = missingStructs;
        return true;
      }
    }

    if (
      !this.pendingStructsSyncThreshold ||
      this.pendingStrcutSyncCount < this.pendingStructsSyncThreshold
    ) {
      this.pendingStrcutSyncCount++;
      return true;
    } else {
      this._pendingStructsSyncReachedThreshold$.next();
      return false;
    }
  }

  /**
   * Sets the last pending structs to prevent sync because of the same missing structs
   * @param missingStructs Current missing structs to set as last pending
   */
  public updateFirstLoadPendingStructs(missingStructs: Map<number, number>): void {
    this.lastPendingStructs = missingStructs;
    if (this.pendingStructsSyncThreshold) {
      this.pendingStrcutSyncCount = this.pendingStructsSyncThreshold;
    }
  }
}
